import { AgentResponse } from 'apis/business/agent/types';
import { createContext, useState, useContext, ReactNode } from 'react';
import { CacheKeys } from 'utils/cacheKeys';

type AgentContextType = {
  selectedAgent: AgentResponse | undefined;
  setSelectedAgent: (Agent: AgentResponse | undefined) => void;
  selectedAgentId: number | undefined;
  setSelectedAgentId: (Agent: number | undefined) => void;
};

const AgentContext = createContext<AgentContextType | undefined>(undefined);

type AgentProviderProps = {
  children: ReactNode;
};

export const AgentProvider = ({ children }: AgentProviderProps) => {
  const [selectedAgent, setSelectedAgent] = useState<AgentResponse | undefined>(undefined);

  let agentId;
  if (localStorage.getItem(CacheKeys.selectedAgentId)) {
    agentId = JSON.parse(localStorage.getItem(CacheKeys.selectedAgentId) ?? '');
  }
  const [selectedAgentId, setSelectedAgentId] = useState<number | undefined>(agentId);

  return (
    <AgentContext.Provider value={{ selectedAgent, setSelectedAgent, selectedAgentId, setSelectedAgentId }}>
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = () => {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error('useAgent must be used within a AgentProvider');
  }
  return context;
};
